<template>
  <div>
    <div v-if="!pageLoading">
      <back-nav :to="$route.name === 'RenewPolicy' ? 'BranchSelectionReview' : 'BranchSelections'" />
      <v-card flat class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-4">
        <h3 class="c-blue-text c-title tw-text-base md:tw-text-xl tw-px-0 md:tw-px-10">
          Full Payment
          <hr class="tw-mt-4">
        </h3>
        <div class="tw-w-full tw-flex">
          <div class="tw-w-full tw-flex tw-justify-center tw-items-center tw-my-5 md:tw-my-8 tw-flex-wrap">
            <div class="tw-flex tw-px-2 md:tw-px-10">
              <v-icon color="primary" size="90" alt="car">mdi-car-outline</v-icon>
              <h3 class="c-navy-text c-title tw-text-base md:tw-text-xl tw-px-2 md:tw-px-8">
                <span v-html="coverType.covertypeId === 101 ? 'Comprehensive <br> Insurance Cover' : coverType.covertypeId === 106 ? 'Third Party <br> Only' : 'Bima Bamba'"></span></h3>
            </div>
            <div class="tw-px-0 md:tw-px-10 tw-mt-5 md:tw-mt-0 tw-text-center lg:tw-text-left">
              <h4 class="c-blue-text tw-font-bold tw-text-sm">Total Annual Premium</h4>
              <h3 class="c-light-blue-text title-font tw-text-4xl md:tw-text-5xl">Kshs. {{ premiumAmount | formatNum }}</h3>
              <v-btn color="secondary" class="tw-mt-2" large block :loading="loading" @click="proceed(premiumAmount, 100)">Confirm and Pay</v-btn>
            </div>
          </div>
        </div>
      </v-card>
      <v-card flat v-if="coverType.covertypeId === 101" class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-4 tw-mt-5 md:tw-mt-10 tw-pb-5">
        <h3 class="c-blue-text c-title tw-text-base md:tw-text-xl tw-px-0 md:tw-px-10">
          Installment Payment
          <hr class="tw-mt-4">
        </h3>
        <div class="tw-w-full tw-flex tw-flex-col">
          <div class="tw-w-full tw-flex tw-justify-center tw-my-2 md:tw-my-4">
            <v-card class="tw-flex tw-items-center tw-flex-wrap tw-justify-center tw-p-4 md:tw-p-6 tw-mt-4">
              <div class="tw-flex tw-grid tw-grid-cols-1 tw-px-2 md:tw-px-10 c-navy-text">
                <p>First Installment</p>
                <h1 class="tw-w-full tw-font-bold tw-text-6xl">40%</h1>
                <p class="tw-w-full tw-text-base">of total premium</p>
              </div>
              <div class="tw-px-0 md:tw-px-10 tw-mt-5 md:tw-mt-0">
                <h4 class="c-blue-text tw-font-bold tw-text-sm">Payable Amount</h4>
                <h3 class="c-light-blue-text title-font tw-text-4xl md:tw-text-5xl">Kshs. {{ installments[0].amount | formatNum }}</h3>
                <v-btn color="secondary" class="tw-mt-2" large block :loading="loading1" @click="proceed(installments[0].amount, 40)">Confirm and Pay</v-btn>
              </div>
            </v-card>
          </div>
          <div class="tw-w-full tw-flex tw-justify-center tw-my-2 md:tw-my-4">
            <v-card class="tw-flex tw-items-center tw-flex-wrap tw-justify-center tw-p-4 md:tw-p-6 tw-mt-4">
              <div class="tw-flex tw-grid tw-grid-cols-1 tw-px-2 md:tw-px-10 c-navy-text">
                <p>Second Installment</p>
                <h1 class="tw-w-full tw-font-bold tw-text-6xl">30%</h1>
                <p class="tw-w-full tw-text-base">of total premium</p>
              </div>
              <div class="tw-px-0 md:tw-px-10 tw-mt-5 md:tw-mt-0">
                <h4 class="c-blue-text tw-font-bold tw-text-sm">Payable Amount</h4>
                <h3 class="c-light-blue-text title-font tw-text-4xl md:tw-text-5xl">Kshs. {{ installments[1].amount | formatNum }}</h3>
                <h4 class="c-blue-text tw-font-bold tw-text-base tw-mt-2">Due {{ addMonths(1) }}</h4>
              </div>
            </v-card>
          </div>
          <div class="tw-w-full tw-flex tw-justify-center tw-my-2 md:tw-my-4">
            <v-card class="tw-flex tw-items-center tw-flex-wrap tw-justify-center tw-p-4 md:tw-p-6 tw-mt-4">
              <div class="tw-flex tw-grid tw-grid-cols-1 tw-px-2 md:tw-px-10 c-navy-text">
                <p>Third Installment</p>
                <h1 class="tw-w-full tw-font-bold tw-text-6xl">30%</h1>
                <p class="tw-w-full tw-text-base">of total premium</p>
              </div>
              <div class="tw-px-0 md:tw-px-10 tw-mt-5 md:tw-mt-0">
                <h4 class="c-blue-text tw-font-bold tw-text-sm">Payable Amount</h4>
                <h3 class="c-light-blue-text title-font tw-text-4xl md:tw-text-5xl">Kshs. {{ installments[2].amount | formatNum }}</h3>
                <h4 class="c-blue-text tw-font-bold tw-text-base tw-mt-2">Due {{ addMonths(2) }}</h4>
              </div>
            </v-card>
          </div>
        </div>
      </v-card>
    </div>
    <div v-else class="tw-w-full tw-flex tw-justify-center">
      <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import BackNav from '@/components/buy/BackNav';
import helpers from '@/utils/helpers';
import { addMonths } from '@/utils/time';
import { FB_BUY_FULL_PAYMENT, FB_BUY_INSTALMENT_PAYMENT } from '@/utils/const';

export default {
  name: 'PaymentSelection',
  props: {
    getQuote: Object,
    batchId: {
      required: false,
      default: null,
    },
  },
  components: { BackNav },
  data() {
    return {
      loading: false,
      loading1: false,
      pageLoading: false,
    };
  },
  computed: {
    coverType() {
      return this.$route.name === 'BuyCover' ? this.getQuote.covertypes.find((e) => e.riskId === parseInt(this.$route.query.b, 10)) : this.getQuote.covertypes.find((id) => id.selected === 'Y');
    },
    installments() {
      return this.getQuote.covertypes.find((e) => e.covertypeId === 101).riskPremDto.installments;
    },
    premiumAmount() {
      return this.coverType.riskPremDto.totalPremium;
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    proceed(amount, percentage) {
      const payment = {
        payableAmount: amount,
        // payableAmount: 1,
        kraPin: this.getQuote.client.kraPinNumber,
        transactionReference: this.coverType.car.registrationNumber,
        transactionDescription: this.batchId !== null ? `ren-${this.batchId}` : `rfq-${this.getQuote.quoteId}`,
        customerPhoneNumber: this.getQuote.client.mobileNumber,
      };
      const quoteInfo = {
        // eslint-disable-next-line no-nested-ternary
        coverType: this.coverType.covertypeId === 101 ? 'Comprehensive <br> Insurance Cover' : this.coverType.covertypeId === 106 ? 'Third Party <br> Only' : 'Bima Bamba',
        payPercentage: percentage,
      };
      this.$analytics.logEvent(percentage === 100 ? FB_BUY_FULL_PAYMENT : FB_BUY_INSTALMENT_PAYMENT);
      this.$emit('to-make-payment', { data: { payment, quoteInfo } });
    },
    addMonths,
  },
  filters: {
    formatNum(num) {
      return helpers.numberToString(num);
    },
  },
};
</script>
